import React, { useMemo } from 'react';

import { DATA_TESTS } from '../../Insurance.constants';

import { TYPES } from './VinOrBodyNumberInput.constants';
import { useVinOrBodyNumberInputPresenter } from './VinOrBodyNumberInput.presenter';
import * as S from './VinOrBodyNumberInput.styles';

const VinOrBodyNumberInput = ({ labels, masks = {}, ...rest }) => {
  const presenter = useVinOrBodyNumberInputPresenter({ labels, masks });
  const { disabled, loading, onVinRecognition, type, value } = presenter;

  const controls = useMemo(() => {
    if (type !== TYPES.VIN || !value) {
      return;
    }

    if (loading) {
      return <S.Spinner />;
    }

    return (
      <S.Button
        dataTest={DATA_TESTS.VIN_RECOGNITION_BUTTON}
        disabled={disabled}
        onClick={onVinRecognition}
      >
        Распознать авто
      </S.Button>
    );
  }, [type, value, loading, disabled, onVinRecognition]);

  return (
    <S.TextInputMasked
      {...rest}
      controls={controls}
      disabled={presenter.disabled}
      error={presenter.error}
      label={presenter.label}
      mask={presenter.mask}
      regular={presenter.type === TYPES.VIN}
      value={presenter.value}
      onChange={presenter.onChange}
    />
  );
};

VinOrBodyNumberInput.TYPES = TYPES;

export { VinOrBodyNumberInput };
